<template>
  <div id="palleting-page" class="my-app">
    <div class="header">
      <v-header></v-header>
    </div>
    <div class="control-panel shadow">
      <palleting-filter
        :filter="filter"
        :pallets="pallets"
        :trucks="trucks"
        @filterUpdated="updateFilter"
        @filterDispatchedChanged="filterDispatched"
      ></palleting-filter>
    </div>
    <div class="content">
      <div class="orders-content shadow">
        <div class="list-header shadow">
          <input class="check" type="checkbox" checked="checked" />
          <span>{{ $t("orders_list.orders") }}: {{ orders.length }}</span>
          <div class="create-new-pallets-button" @click="openNewPalletsPage">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="user.type != 6"
                  class="pallets-button"
                  flat
                  icon
                  color="black"
                  v-on="on"
                  @click="openNewPalletsPage"
                >
                  <v-icon large>chevron_right</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("palleting_page.new_pallets") }}</span>
            </v-tooltip>
          </div>
        </div>
        <orders-list
          ref="ordersList"
          v-if="orders.length > 0"
          :orders="orders"
          :pallets="pallets"
          :user="user"
          @selectAll="selectAll"
          @selectProduct="selectProduct"
          @productSelected="showProduct"
          @hideProduct="hideProduct"
          @loaded="selectAllProducts"
          @updated="initialize"
        ></orders-list>
      </div>
      <div class="main-content shadow" :class="{ 'main-content-small': !showPallet }">
        <div class="list-header shadow">
          <div class="pallets-count">
            <input
              id="check-all-checkbox"
              class="check"
              type="checkbox"
              @input="checkAllPallets($event)"
            />
            <span>{{ $t("pallets_list.pallets") }}: {{ pallets.length }}</span>
          </div>
          <div class="general-controls">
            <general-controls
              :pallets="pallets"
              :trucks="trucks"
              :selectedPallets="selectedPallets"
              :client="client"
              :showPallet="showPallet"
              @openNewTruck="openNewTruckPage"
              @createNewPallet="openCreatePallet"
              @createNewFictivePallet="openCreateFictivePallet"
              @updated="initialize"
              @editPallets="openPalletsEditor"
              @moveProducts="openProductSwapper"
              @uncheck="uncheckPallets"
            ></general-controls>
          </div>
        </div>
        <div class="pallet-content" v-if="pallets.length > 0">
          <div id="pallet-editting-window" class="pallet-editor" v-if="showPallet">
            <pallet-editor
              ref="palletEditor"
              :user="user"
              :pallet="selectedPallet"
              @productSelected="showProduct"
              @hideProduct="hideProduct"
              @updated="initialize"
            ></pallet-editor>
          </div>
          <div class="shadow" :class="{ 'pallets-list-small': showPallet }">
            <pallets-list
              ref="palletsList"
              v-if="pallets.length > 0"
              :pallets="pallets"
              :showPallet="showPallet"
              :showingPalletIndex="selectedPalletIndex"
              :client="client"
              :user="user"
              @switchView="showPallet = !showPallet"
              @palletSelected="changeSelectedPallet"
              @palletChecked="checkPallet"
              @palletUnchecked="uncheckPallet"
              @removeTemporary="removeTemporaryPallet"
              @productSelected="showProduct"
              @hideProduct="hideProduct"
              @openPalletEdittor="openPalletEditor"
              @openPallet="openPalletView"
              @palletCreated="addTemporaryPallet"
              @openPalletViewing="openPallet3D"
              @changeNumber="changePalletNumber"
              @updated="initialize"
            ></pallets-list>
          </div>
        </div>
      </div>
      <div class="trucks-list shadow" v-if="!showPallet">
        <div class="list-header shadow">
          <span class="trucks-count">{{ $t("palleting_page.trucks") }}{{ trucks.length }}</span>
          <div class="pdf-button" :class="{'read-only': user.type == 6}">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="pallets-button" large flat icon color="black" v-on="on">
                  <v-icon large>print</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="exportPdf('truckExport')" v-if="trucks.length > 0">
                  <v-list-tile-title>{{ $t("general_controls.truck_pdf") }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="exportPdf('loadingExport')" v-if="confirmedCount() > 0">
                  <v-list-tile-title>{{ $t("general_controls.loading_pdf") }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
          <div class="new-truck-button" v-if="user.type != 6">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn large flat icon color="black" v-on="on" @click="openNewTruckPage">
                  <v-icon large>local_shipping</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("general_controls.new_truck") }}</span>
            </v-tooltip>
          </div>
          <div class="show-pallets-button unselectable" @click="showPallet = !showPallet">
            <div class="show-pallets-icon">
              <v-btn class="pallets-button" flat icon color="black">
                <v-icon large color="white">arrow_right</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <trucks-list
          v-if="trucks.length > 0"
          :trucks="trucks"
          :orders="orders"
          :allPallets="pallets"
          :pallets="selectedPallets"
          :user="user"
          @edittingTruckSelected="openTruckEditor"
          @palletSelected="openTruckPallet"
          @updated="initialize"
          @addedPallet="addPallet"
        ></trucks-list>
      </div>
      <div
        class="side-drawer shadow unselectable"
        @click="showPallet = !showPallet"
        v-if="showPallet"
      >
        <div class="pointer-arrow">
          <span>&#9664;</span>
        </div>
        <div class="trucks-text">
          <span>{{ $t("trucks_list.trucks") }}: {{ trucks.length }}</span>
        </div>
      </div>
      <div class="new-pallets">
        <pallets-configurator
          ref="palletsConfigurator"
          v-if="orders.length > 0"
          :orders="orders"
          :products="selectedProducts"
          :client="client"
          @newPallets="updatePalletsList"
          @palletsUpdated="updatePallets"
          @palletCreated="addTemporaryPallet"
        ></pallets-configurator>
      </div>
      <div class="fictive-pallets">
        <fictive-pallet-maker
          ref="fictivePalletMaker"
          v-if="orders.length > 0"
          :orders="orders"
          @created="updatePalletsList"
        ></fictive-pallet-maker>
      </div>
      <div class="new-truck">
        <truck-maker
          ref="truckMaker"
          v-if="orders.length > 0"
          :orders="orders"
          :pallets="selectedPallets"
          @newTruck="updateTrucksList"
        ></truck-maker>
      </div>
      <div :style="previewStyle">
        <product-preview ref="productPreview"></product-preview>
      </div>
      <div class="truck-editor">
        <truck-edit
          v-if="orders.length > 0"
          ref="truckEditor"
          :allPallets="pallets"
          :orders="orders"
          @truckUpdated="updateTruckEditor"
        ></truck-edit>
      </div>
      <div class="product-swapper">
        <product-swapper
          v-if="pallets.length > 0"
          ref="productSwapper"
          :pallets="getOwnedPallets()"
          @updated="initialize"
          @productSelected="showProduct"
          @hideProduct="hideProduct"
          @removeTemporary="removeTemporaryPallet"
          @unselect="uncheckPallets"
        ></product-swapper>
      </div>
      <div class="pallet-preview-3d">
        <pallet-preview-dialog ref="palletPreviewDialog" />
      </div>
      <div class="change-pallet-number">
        <change-pallet-number-dialog ref="changePalletNumberDialog" @updated="initialize" />
      </div>
    </div>
  </div>
</template>

<script>
import Helper from "@/models/Helper.js";
import Order from "@/models/Order.js";
import HttpClient from "@/models/HttpClient.js";
import VHeader from "@/components/header.vue";
import OrdersList from "@/components/palleting/OrdersList.vue";
import PalletsList from "@/components/palleting/PalletsList.vue";
import PalletEditor from "@/components/palleting/PalletEditor.vue";
import PalletsConfigurator from "@/components/palleting/PalletsConfigurator.vue";
import TrucksList from "@/components/palleting/TrucksList.vue";
import GeneralControls from "@/components/palleting/GeneralControls.vue";
import TruckMaker from "@/components/palleting/TruckMaker.vue";
import PalletingFilter from "@/components/palleting/PalletingFilter.vue";
import ProductPreview from "@/components/user/products/ProductPreview.vue";
import TruckEdit from "@/components/palleting/TruckEdit.vue";
import ProductSwapper from "@/components/palleting/ProductSwapper.vue";
import FictivePalletMaker from "@/components/palleting/FictivePalletMaker.vue";
import PalletPreviewDialog from "@/components/palleting/PalletPreviewDialog.vue";
import ChangePalletNumberDialog from "@/components/palleting/ChangePalletNumberDialog.vue";
import Pallet from "@/models/Pallet.js";
import Export from "@/models/Export.js";
import User from "@/models/User.js";
export default {
  name: "palleting-page",
  data() {
    return {
      filter: {
        filter: this.$route.params.filter ? this.$route.params.filter : "",
        pal_status_from: 1,
        pal_status_to: 2,
      },
      orders: [],
      pallets: [],
      trucks: [],
      selectedPallet: {},
      selectedPalletIndex: 0,
      showPallet: true,
      selectedProducts: [],
      selectedPallets: [],
      tempPallet: null,
      client: new HttpClient(),
      cursorPosition: null,
      initialLoading: true,
      user: new User(this.$session.get("user")),
    };
  },
  computed: {
    previewStyle() {
      if (!this.cursorPosition) return;
      return {
        "z-index": 1000,
        position: "fixed",
        top: this.cursorPosition.y + 10 + "px",
        left: this.cursorPosition.x + 10 + "px",
      };
    },
  },
  created() {
    this.initialize();
    document.addEventListener("mousemove", this.onMouseMove, false);
  },
  methods: {
    async initialize() {
      const filterParts = this.filter.filter.split(",");
      for (let i = 0; i < filterParts.length; i++) {
        if (filterParts[i].trim().length < 3) {
          return;
        }
      }
      //gets prepared data
      const { pallets, orders, trucks } = await Order.getOrderPalleting(
        this.filter
      );
      this.pallets = this.tempPallet ? [...pallets, this.tempPallet] : pallets;
      this.orders = orders;
      this.trucks = trucks;
      this.selectedProducts = [];
      //do once
      if (this.initialLoading) {
        this.showPallet = trucks.length == 0 ? true : false;
      }
      this.initialLoading = false;
      this.$store.commit("setLoading", false);
      if (pallets.length > 0)
        this.selectedPallet = pallets[this.selectedPalletIndex];
      if (this.$refs.hasOwnProperty("truckEditor")) {
        this.$refs.truckEditor.update(trucks);
      }
    },
    checkUser() {
      if (this.user.company_id == 9) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
    },
    updateFilter(filter) {
      this.filter.filter = filter;
      this.initialize();
    },
    filterDispatched(dispatched) {
      this.filter.pal_status_to = dispatched ? 3 : 2;
      this.initialize();
    },
    changeSelectedPallet(index) {
      this.selectedPalletIndex = index;
      this.selectedPallet = this.pallets[index];
    },
    openNewPalletsPage() {
      if (this.$refs.palletsConfigurator) {
        this.$refs.palletsConfigurator.openCreating();
      }
    },
    openNewTruckPage() {
      if (this.$refs.truckMaker) {
        this.$refs.truckMaker.open();
      }
    },
    openTruckEditor(truck) {
      this.$refs.truckEditor.open(truck);
    },
    async updateTruckEditor(truck) {
      await this.initialize();
      const updatedTruck = this.trucks.find((e) => {
        return truck.id == e.id;
      });
      this.$refs.truckEditor.updateTruck(updatedTruck);
    },
    openProductSwapper() {
      if (this.$refs.productSwapper) {
        this.$refs.productSwapper.open(
          this.selectedPallets.filter((pallet) => {
            return pallet.owned;
          })
        );
      }
    },
    openCreatePallet() {
      if (this.$refs.palletsConfigurator) {
        this.$refs.palletsConfigurator.openCreatingTemporary();
      }
    },
    openCreateFictivePallet() {
      if (this.$refs.fictivePalletMaker) {
        this.$refs.fictivePalletMaker.open();
      }
    },
    selectAll(order) {
      order.products.forEach((product) => {
        if (product.pallet_id == null) {
          this.selectProduct(product);
          product.checked = !order.checked;
        }
      });
    },
    checkAllPallets($event) {
      this.$refs.palletsList.checkAllPallets($event);
    },
    selectAllProducts() {
      const selectedProducts = [];
      for (const order of this.orders) {
        for (const product of order.products) {
          if (product.pallet_id == null) {
            selectedProducts.push(product);
          }
        }
      }
      this.selectedProducts = selectedProducts;
    },
    selectProduct(product) {
      if (!product.checked) {
        this.selectedProducts.push(product);
      } else {
        const foundIndex = this.selectedProducts.indexOf(product);
        if (foundIndex != -1) {
          this.selectedProducts.splice(foundIndex, 1);
        }
      }
    },
    updatePalletsList() {
      this.selectedProducts = [];
      this.orders.forEach((order) => {
        order.products.forEach((product) => {
          product.checked = false;
        });
      });
      this.initialize();
    },
    uncheckPallets() {
      this.selectedPallets = [];
      this.$refs.palletsList.uncheckAllPallets();
    },
    updatePallets() {
      this.uncheckPallets();
      this.initialize();
    },
    updateTrucksList() {
      this.selectedPallets = [];
      this.$refs.palletsList.uncheckAllPallets();
      this.showPallet = false;
      this.initialize();
    },
    checkPallet(pallet) {
      const foundIndex = this.selectedPallets.indexOf(pallet);
      if (foundIndex === -1 && !pallet.temporary) {
        this.selectedPallets.push(pallet);
      }
    },
    uncheckPallet(pallet) {
      const foundIndex = this.selectedPallets.indexOf(pallet);
      if (foundIndex != -1) {
        this.selectedPallets.splice(foundIndex, 1);
      }
    },
    addPallet() {
      this.selectedPallets = [];
      this.$refs.palletsList.uncheckAllPallets();
      this.initialize();
    },
    addTemporaryPallet(pallet) {
      if (this.tempPallet) {
        this.pallets.splice(this.pallets.length - 1, 1);
      }
      this.tempPallet = pallet;
      this.pallets = [...this.pallets, pallet];
    },
    showProduct(product) {
      this.$refs.productPreview.showProduct(product);
    },
    hideProduct() {
      if (this.$refs.productPreview) {
        this.$refs.productPreview.hideProduct();
      }
    },
    removeTemporaryPallet() {
      this.tempPallet = null;
      this.pallets.splice(this.pallets.length - 1, 1);
    },
    openPalletsEditor() {
      if (this.$refs.palletsConfigurator) {
        this.$refs.palletsConfigurator.openEditting(
          Pallet.getOwnedPallets(this.selectedPallets)
        );
      }
    },
    openPalletEditor(pallet) {
      this.$refs.palletsConfigurator.openEditting(pallet);
    },
    openPallet3D(pallet) {
      this.$refs.palletPreviewDialog.open(pallet);
    },
    changePalletNumber(pallet) {
      this.$refs.changePalletNumberDialog.open(pallet);
    },
    async openPalletView() {
      await Helper.timeout(100);
      this.showPallet = true;
    },
    onMouseMove(e) {
      this.hideProduct();
      this.cursorPosition = {
        x: e.clientX,
        y: e.clientY,
      };
    },
    async exportPdf(pdf) {
      const pallets =
        this.selectedPallets.length == 0 ? this.pallets : this.selectedPallets;
      const myPdf = Object.create({ action: pdf });
      const pdfHelper = new Export(pallets, this.trucks, this.client);
      this.$store.commit("setLoading", true);
      await pdfHelper[myPdf.action](this);
      this.$store.commit("setLoading", false);
      this.uncheckPallets();
      this.initialize();
    },
    confirmedCount() {
      return Pallet.confirmed(this.pallets);
    },
    getOwnedPallets() {
      return Pallet.getOwnedPallets(this.pallets);
    },
    openTruckPallet(pallet) {
      const index = this.pallets.indexOf(pallet);
      this.changeSelectedPallet(index);
      this.$refs.palletsList.scrollToPallet(pallet);
    },
  },
  components: {
    GeneralControls,
    VHeader,
    OrdersList,
    PalletsList,
    PalletEditor,
    PalletsConfigurator,
    TruckMaker,
    TrucksList,
    PalletingFilter,
    ProductPreview,
    TruckEdit,
    ProductSwapper,
    FictivePalletMaker,
    PalletPreviewDialog,
    ChangePalletNumberDialog,
  },
};
</script>

<style>
.my-app {
  position: absolute;
  width: 100%;
  height: 100%;
}
.header {
  position: relative;
  width: 100%;
  height: 70px;
  margin-bottom: 5px;
}
.control-panel {
  position: relative;
  left: 10px;
  width: calc(100% - 20px);
  height: 30px;
  margin-bottom: 10px;
}
.content {
  position: relative;
  width: 100%;
  height: calc(100% - 130px);
}
.orders-content {
  position: relative;
  left: 10px;
  width: calc(15% - 10px);
  height: calc(100%);
}
.main-content {
  position: absolute;
  top: 0;
  left: calc(15% + 10px);
  width: calc(100% - 15% - 60px);
  height: 100%;
}
.main-content-small {
  width: calc(50% - 7.5% - 15px);
}
.trucks-list {
  position: absolute;
  top: 0;
  left: calc(15% + 50% - 7.5% + 5px);
  width: calc(50% - 7.5% - 15px);
  height: 100%;
}
.pallet-content {
  position: relative;
  width: 100%;
  height: calc(100% - 50px);
}
.side-drawer {
  position: absolute;
  right: 10px;
  top: 0;
  width: 30px;
  height: 100%;
  cursor: pointer;
  background: rgba(25, 118, 210, 0.514);
}
.show-pallets-button {
  position: absolute;
  height: 30px;
  width: 50px;
  left: 0;
  vertical-align: middle;
  cursor: pointer;
}
.show-pallets-icon {
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
}
.pointer-arrow {
  font-size: 24px;
  text-align: center;
  color: white;
}
.trucks-text {
  font-weight: 800;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  writing-mode: vertical-lr;
  text-orientation: mixed;
}
.pallet-editor {
  position: absolute;
  top: 0;
  left: 5px;
  width: calc(50% - 5px);
  height: 100%;
}
.pallets-list-small {
  position: absolute;
  top: 0;
  right: 0;
  width: calc(50% - 5px);
  height: 100%;
}
.shadow {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22) !important;
}
.list-header {
  position: relative;
  height: 50px;
  background: rgba(25, 118, 210, 0.514);
  font-weight: 500;
  padding-left: 20px;
  font-size: 16px;
  text-align: center;
}
.list-wrapper {
  position: absolute;
  width: 100%;
  height: calc(100% - 50px);
}
.panel-scrollable {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.panel-scrollable::-webkit-scrollbar {
  width: 10px;
}

.panel-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.panel-scrollable::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
.check {
  width: 24px;
  height: 24px;
  position: relative;
  top: 3px;
}
.settings {
  font-weight: 1000;
  font-size: 20px;
}
.unselectable {
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}
.create-new-pallets-button {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}
.general-controls {
  position: absolute;
  right: 0;
  top: 0;
  height: 50px;
}
.trucks-count {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.new-truck-button {
  position: absolute;
  right: 0;
}
.pdf-button {
  position: absolute;
  right: 50px;
}
.read-only {
  right: 0;
}
</style>
